module.exports = __webpack_public_path__ + "static/media/write.a706458b.svg";